mod.modules.define("InfoBanner", function(fn) {

	fn.prototype.init = function(params) {
		// Attach the scrolling behavior
		this.el.find("ul").rolodex({
			autoScroll : true,
			direction : "top"
		});
	};

});